import { BuyNowService } from '../services/buy-now.service';
import { ColCatService } from '../../shop/services/col-cat.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DetectScreenService } from '../../shop/services/detect-screen.service';
import { FirestoreProductsService } from '../services/firestore-products.service';
import { LocalStorageService } from '../services/local-storage.service';
import { PricesService } from '../services/prices.service';
import { ProductRangeService } from '../services/product-range.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import tableCheck from '../../../assets/meta-data/table-types.json';

@Component({
  selector: 'app-category-child',
  styleUrls: ['./category-child.component.scss'],
  templateUrl: './category-child.component.html'
})

export class CategoryChildComponent implements OnDestroy, OnInit {

  private categoryProduct: string;
  private collection: string;
  private collectionChild: string;
  private collections: any[];
  private collectionCheck: string;
  private collectionLength: number;
  private cost: number;
  private currentView: string;
  private delivery: number;
  private depth: number;
  private discount: number;
  private filteredProducts: any;
  private finalPrice: number;
  private isRectangleTable: boolean;
  private markup: number;
  private monthEval: number;
  private monthlyPrice: number;
  private ownDiscount: number;
  private parentVal: string;
  private price: number;
  private renewDiscount: number;
  private route: any;
  private routerVal: string;
  private subCollections: any[];
  private subscription: Subscription;
  private subscriptionPrice;
  private tablePrice: number;
  private tableSize: string;
  private tax: number;
  private topCost: number;
  private totalCollectionCost: number;
  private width: number;

  public area: string;
  public areaState: boolean;
  public buyState: boolean;
  public categories: any[];
  public productList: object;
  public screenWidth: number;
  public subCategories: any[];

  // Customize it my way properties
  private concreteTop: boolean;
  private glassTop: boolean;
  private marbleTop: boolean;
  private tableTopSelection: string;
  private woodTop: boolean;

  constructor(
    private buyNow: BuyNowService,
    public ls: LocalStorageService,
    public router: Router,

    private colCatService: ColCatService,
    private detectScreen: DetectScreenService,
    private pricesService: PricesService,
    private productRange: ProductRangeService,
    private fsProducts: FirestoreProductsService
  ) {
    this.topCost = this.pricesService.concrete;
    this.subscription =
    this.buyNow.getStatus().subscribe(status => this.buyState = status),
      this.colCatService.getCollections().subscribe(data => this.collections = data),
      this.colCatService.subCollection().subscribe(data => this.subCollections = data),
      this.colCatService.category().subscribe(data => this.categories = data),
      this.colCatService.subCategory().subscribe(data => this.subCategories = data);

    this.subscription = this.ls.areaReturn().subscribe(boolean => this.areaState = boolean);

    this.catFilter();
    // this.checkTable();
    this.initPriceConstants();
    this.subcribeMonth();
    this.subcribeArea();
  }

  ngOnInit(): void {
    this.setFilter();

    this.titleCase(2, 'currentView');
    this.titleCase(1, 'parentVal');

    console.log(this.router.url.split('/'));

    this.initLsValues();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private buyProduct(set: boolean): void {
    this.buyNow.setBuy(set);
  }

  private catFilter(): void {
    const tempVal: string[] = this.router.url.split('/');
    this.collection = tempVal[1];
    this.collectionChild = tempVal[2];
    this.routerVal = tempVal[3];
  }

  private checkTable() {
    if (this.collection === 'tables') {
      for (let i = 0; i < tableCheck.rectangle.length; i++) {
        if (tableCheck.rectangle[i] === this.productList[0].name) {
          this.isRectangleTable = true;
        } else {
          this.isRectangleTable = false;
        }
      }
    }
  }

  private filterBy(key: string, value: string) {
    this.filteredProducts = this.fsProducts.filterBy(key, value).subscribe(document => {
      console.log(document);
      this.collectionLength = document.length;
      this.productRange.castBaseStamp(document);
      this.subscribeProductRange();
      this.getCollectionCosts();
    });
  }

  private getCollectionCosts(): void {
    this.productRange.productObs().subscribe((documents: any[]) => {
      // this.collectionLength = documents.length;
      const cost: number[] = [];
      for (let i = 0; i < documents.length; i++) {
        cost.push(documents[i].baseCost);
      }
      this.totalCollectionCost = cost.reduce((a, b) => a + b, 0);
      // this.getCosts();
    });
  }

  private initCustomVals(): void {
    this.concreteTop = true;
    this.glassTop = false;
    this.marbleTop = false;
    this.woodTop = false;

    this.tableSize = '4-6';
    this.tableTopSelection = 'concrete';


    if (this.isRectangleTable === true) {
      this.depth = 900;
      this.width = 1200;
    } else {
      this.depth = 1200;
      this.width = 1200;
    }
  }

  private initPriceConstants(): void {
    this.screenWidth = this.detectScreen.getScreen();
    this.cost = 0;
    this.monthEval = 0;
    this.delivery = this.pricesService.delivery;
    this.discount = this.pricesService.discount;
    this.markup = this.pricesService.markup;
    this.ownDiscount = this.pricesService.ownDiscount;
    this.renewDiscount = this.pricesService.renewDiscount;
    this.tax = this.pricesService.taxVal;
  }

  private initLsValues(): void {
    if (localStorage.getItem('monthSelection')) {
      this.ls.monthWrite(localStorage.getItem('monthSelection'));
    } else {
      this.ls.monthWrite('12');
    }
  }

  private monthPrice(cost: number): number {
    const retailPrice = this.sellingPrice(cost);
    const correctCost = this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, retailPrice);
    this.monthlyPrice = correctCost;
    return correctCost;
  }

  private sellingPrice(cost: number): number {
    if (this.collectionChild === 'dining-tables') {
      let depth = this.depth;
      let width = this.width;

      if (this.isRectangleTable === true) {
        if (this.tableSize === '4-6') {
          depth = 900;
          width = 1200;
        } else if (this.tableSize === '6-8') {
          depth = 2000;
          width = 1000;
        } else if (this.tableSize === '8-10') {
          depth = 2750;
          width = 1200;
        }
      } else if (this.isRectangleTable === false) {
        if (this.tableSize === '4-6') {
          depth = 1200;
          width = 1200;
        } else if (this.tableSize === '6-8') {
          depth = 1500;
          width = 1500;
        }
      }

      this.price = this.pricesService.tableSellingPrice(cost, this.delivery, depth, this.markup, this.isRectangleTable, this.tableSize, this.topCost, this.tax, width);

      // console.table([
      //   {'cost': cost},
      //   {'depth': depth},
      //   {'delivery': this.delivery},
      //   {'discount': this.discount},
      //   {'isRectangleTable': this.isRectangleTable},
      //   {'markup': this.markup},
      //   {'monthEval': this.monthEval},
      //   {'ownDiscount': this.ownDiscount},
      //   {'tablePrice': this.tablePrice},
      //   {'tablePrice (with discounts)': this.tablePrice * (1 - (this.ownDiscount / 100)) - (this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, this.tablePrice) * this.monthEval)},
      //   {'tableSize': this.tableSize},
      //   {'tax': this.tax},
      //   {'topCost': this.topCost},
      //   {'width': width},
      // ]);

      return this.price;
      // return this.tablePrice * (1 - (this.ownDiscount / 100)) - (this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, this.tablePrice) * this.monthEval);
    } else if (this.collectionChild !== 'dining-tables') {

      // console.log([
      //   {'cost': this.cost},
      //   {'delivery': this.delivery},
      //   {'markup': this.markup},
      //   {'monthEval': this.monthEval},
      //   {'ownDiscount': this.ownDiscount},
      //   {'tablePrice': this.pricesService.sellingPrice(this.cost, this.delivery, this.markup, this.tax)},
      //   {'tax': this.tax},
      // ]);

      this.price = this.price = this.pricesService.sellingPrice(cost, this.delivery, this.markup, this.tax);
      return this.price;
    }
  }

  private setFilter(): void {
    const tempVal: string[] = this.router.url.split('/');
    this.routerVal = tempVal[2];
    console.log(this.routerVal);
    this.collectionCheck = tempVal[1];
    console.log(this.collectionCheck);
    if (this.collectionCheck === 'collections') {
      this.filterBy('collection', this.routerVal);
    } else {
      console.log(this.routerVal);
      this.filterBy('categoryChild', this.routerVal);
    }
  }

  public subcribeArea(): void {
    this.subscription = this.ls.areaListener().subscribe(area => {
      if (area) {
        this.area = area;
      }
   });
  }

  public subcribeMonth(): void {
    this.subscription = this.ls.monthListener().subscribe(month => {
      if (month) {
        this.monthEval = this.ls.filterInt(month);
      } else {
        this.monthEval = 0;
      }
    });
  }

  public subscribeProductRange(): void {
    this.productRange.productObs().subscribe(documents => {
      this.initCustomVals();
      this.productList = documents;
      console.log(documents);
      console.log(this.productList);
      this.checkTable();
    });
  }

  private titleCase(routerPos: number, property: string) {
    const tempVal: string[] = this.router.url.split('/');
    const toCap = tempVal[routerPos];
    const titleCase: string[] = [];
    const splitRouter = toCap.split('-');
    console.log(toCap.split('-'));

    for (let i = 0; i < splitRouter.length; i++) {
      titleCase.push(splitRouter[i].charAt(0).toUpperCase() + splitRouter[i].substring(1));
    }

    if (property === 'currentView') {
      this.currentView = titleCase.join(' ');
    } else if (property === 'parentVal') {
      this.parentVal = titleCase.join(' ');
    }
  }
}
